import React, { useState, useMemo, useContext } from "react";
import * as Yup from 'yup';
import { XIcon } from '@heroicons/react/outline';
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { PencilAltIcon, PlusCircleIcon } from '@heroicons/react/outline'

import Button from "../../../qg-components/src/libs/Button";
import Form, { FormItem } from "../../../qg-components/src/libs/Form/index";
import Table from "../../../qg-components/src/libs/teTable/index";
import {mutateCreateNote, putUpdateNode} from "../../../redux/reducers/animalResearchSlice";
import { getSeverityStyle } from "../utils/helper";
import { viewImgContext } from "..";

/**
 * 
 * @param {Number} isShowActionNote 是否显现该组件 主要用于显示时的动画class切换 默认-1 显示1 隐藏0
 * @param { Object } studyInfo 向上查询到的study信息 包含animal note slide 信息
 * @param { string } actionNoteType 当前操作的note类型
 * @param { Function } showActionNoteBox 隐藏该组件的函数
 * @param { Function } onSubmit 提交成功的回调
 * @returns 
 */
const ActionNote = (props) => {

  const { isShowActionNote, studyInfo, showActionNoteBox1, actionNoteType, onSubmit, editNote, setEditNote } = useContext(viewImgContext);

  let formItemOption = {
    holdercolor: "placeholder-white",
    bgcolor: "bg-transparent",
    labelclass: "text-white w-5/12",
    color: "text-white",
  };

  const [createNoteType, setCreateNoteType] = useState("");

  const usedispatch = useDispatch();

  const data = useMemo(() => {
    if (studyInfo) {
      return [...studyInfo.SlideNote, ...studyInfo.InterimSlideNote, ...studyInfo.SlideObservation]
    };
    return []
  }, [studyInfo, studyInfo?.SlideNote?.length, studyInfo?.InterimSlideNote?.length, studyInfo?.SlideObservation?.length]);

  const onEditNote = (row) => {
    setEditNote(row);
    setCreateNoteType("");
  };

  const onCreateNote = (row) => {
    setEditNote(null);
    setCreateNoteType(row.original.type);
  };

  const options = {
    data: data,
    columns: [
      {
        Header: "action",
        Cell: ({ row }) => {
          return (
            <div className="flex flex-row">
              <div className="w-5 hover:text-sprimary-700">
                <PencilAltIcon onClick={
                  () => onEditNote(row)
                } className="w-full " />
              </div>
              <div className="w-5 hover:text-sprimary-700">
                <PlusCircleIcon onClick={
                  () => onCreateNote(row)
                } className="w-full " />
              </div>
            </div>
          ) 
        }
      },
      {
        Header: "Directionality",
        accessor: "Directionality"
      }, {
        Header: "Finding",
        accessor: "Finding"
      }, {
        Header: "FindingInhand",
        accessor: "FindingInhand"
      }, {
        Header: "Laterality",
        accessor: "Laterality"
      }, {
        Header: "ServerityInhand",
        accessor: "ServerityInhand"
      }, {
        Header: "Severity",
        accessor: "Severity"
      },{
        Header: "Type",
        accessor: "type"
      }, 
      // {
      //   Header: "action",
      //   Cell: ({ row }) => {
      //     return (
      //       <div className="flex">
      //         <Button color="primary" className="mr-3" onClick={() => {onEditNote(row)}}>edit</Button>
      //         <Button color="primary" className="mr-3" onClick={() => {onCreateNote(row)}}>created</Button>
      //       </div>
      //     ) 
      //   }
      // }
    ],
  };

  const formikOptions = useMemo(() => {
    let initialValues = {
      Directionality: "",
      Finding: "",
      FindingInhand: "",
      Laterality: "",
      ServerityInhand: "",
      Severity: "",
    };

    if(editNote) {
      let { SlideID, ID, ...info } = editNote.original
      initialValues = info;
    };

    return {
      initialValues,
      enableReinitialize:true,
      validationSchema: Yup.object({
        Directionality: Yup.string().required("Directionality is required"),
        Finding: Yup.string().required("Finding is required"),
        FindingInhand: Yup.string().required("FindingInhand is required"),
        Laterality: Yup.string().required("Laterality is required"),
        ServerityInhand: Yup.string().required("ServerityInhand is required"),
        Severity: Yup.string().required("Severity is required")
      }),
  
      onSubmit: (values) => {
        if(!editNote) {
          console.log(studyInfo, createNoteType, actionNoteType)
          let params = { ...values, SlideID: studyInfo.ID, NoteType: createNoteType || actionNoteType};
          usedispatch(mutateCreateNote(params, (info) => {
            onSubmit(values)
          }))
          return;
        };

        let params = { ...values, ID:editNote.original.ID, SlideID: editNote.original.SlideID, NoteType: editNote.original.type };
        usedispatch(putUpdateNode(params, (info) => {
          editNote.setState((oldVal) => ({ ...oldVal, [editNote.original.type]: info }))
          onSubmit(values);
        }));
      }
    }
  }, [editNote, studyInfo, actionNoteType, createNoteType]);

  return (
    <div className={`h-full p-3 absolute flex flex-col border top-0 ${'note' + isShowActionNote}`} style={{ "width": "42rem", "background": "rgba(0,0,0,.3)" }}>
      <header className="flex flex-shrink-0 w-full justify-between mb-3"> <i></i><XIcon onClick={showActionNoteBox1} className="cursor-pointer w-6 text-white"></XIcon></header>
      <div className="w-full flex-1 overflow-y-scroll scrollbar">
        <div className="w-full p-3 flex-shrink-0 overflow-hidden rounded" style={{"background": `rgba(255,255,255,.5)`}}>
          <Table {...options} tableTheme="white"></Table>
        </div>

        <div className="w-full p-3">
          <Form {...formikOptions} className="px-3 w-full">
            <div className="flex w-full justify-between">
              <FormItem {...formItemOption} textarreaclass="bg-transparent" type="textArea" placeholder="Finding" id="Finding" name="Finding" labelname="Finding"></FormItem>
              <FormItem {...formItemOption} textarreaclass="bg-transparent" type="textArea" placeholder="FindingINHAND" id="FindingInhand" name="FindingInhand" labelname="FindingINHAND"></FormItem>
            </div>

            <div className="flex w-full justify-between">
              <FormItem {...formItemOption}  
                placeholder="Severity" id="Severity" name="Severity" 
                labelname="Severity"
                onChange={
                  (e) => {
                    console.log(e)
                  }
                }
              ></FormItem>
              <FormItem {...formItemOption} placeholder="ServerityINHAND" id="ServerityInhand" name="ServerityInhand" labelname="ServerityINHAND"></FormItem>
            </div>
            
            <div className="flex w-full justify-between">
            <FormItem {...formItemOption} placeholder="Directionality" id="Directionality" name="Directionality" labelname="Directionality"></FormItem>
              <FormItem {...formItemOption} placeholder="Laterality" id="Laterality" name="Laterality" labelname="Laterality"></FormItem>
            </div>
            <div className="w-full flex justify-center mt-5 mb-5">
              <Button className="mr-8" color="success" submit={true}>Confirm</Button>
              <Button className="ml-8" onClick={showActionNoteBox1}>Cancel</Button>
            </div>
          </Form>

          
        </div>
      </div>
    </div>
  )
};

export default ActionNote;